// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__382-X","legacyBtn":"MutateMid_legacyBtn__3aUVe"};